import { useFlag } from '@unleash/proxy-client-vue'
import { computed, type ComputedRef, type MaybeRefOrGetter, toValue } from 'vue'

import { FLAG_PARTICIPANT_PAYMENT_SPLIT } from '@/lib/constants/flags'
import type { CampaignType } from '@/types/campaign'

type CampaignPayment = Pick<CampaignType, 'additionalPayment' | 'additionalPaymentRevenueInvoice'>

export const useCampaignDefaultPayment = (
  campaign: MaybeRefOrGetter<CampaignPayment | null | undefined>,
): ComputedRef<number> => {
  const isPaymentSplitEnabled = useFlag(FLAG_PARTICIPANT_PAYMENT_SPLIT)

  return computed(() => {
    const value = toValue(campaign)
    const additionalPayment = value?.additionalPayment ?? 0
    return isPaymentSplitEnabled.value
      ? (value?.additionalPaymentRevenueInvoice ?? additionalPayment)
      : additionalPayment
  })
}
